/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
          //define functions
          var waitForFinalEvent = (function () {
            var timers = {};
            return function (callback, ms, uniqueId) {
              if (!uniqueId) { uniqueId = "Don't call this twice without a uniqueId"; }
              if (timers[uniqueId]) { clearTimeout (timers[uniqueId]); }
              timers[uniqueId] = setTimeout(callback, ms);
            };
          })();

          // how long to wait before deciding the resize has stopped, in ms. Around 50-100 should work ok.
          var timeToWaitForLast = 100;

        //sticky menu
        $( window ).scroll(function() {
          if ( $(window).scrollTop() > 0 ) {
            if ( ! $('.banner').hasClass('banner--scrolled') ) {
              $('.banner').addClass('banner--scrolled');
            }
          } else {
            if ( $('.banner').hasClass('banner--scrolled') ) {
              $('.banner').removeClass('banner--scrolled');
            }
          }
        });

        //scroll effects - scrollspy and animation of lines surrounding titles
        var sections = $('.anvol-menu-section')
          , nav = $('.nav').not(":has(.anvol-section__early-activator)")
          , nav_height = nav.outerHeight()
          , early_activators = $('.anvol-section__early-activator');

        $(window).on('scroll', function () {
          var cur_pos = $(this).scrollTop();

          if (cur_pos==0) {
            nav.find('a').parent().removeClass('active');
            sections.find('.anvol-title:not(.anvol-title--no-lines)').removeClass('anvol-title--active');
            return
          };

          early_activators.each(function() {
            var top = $(this).offset().top - nav_height,
              bottom = top + $(this).outerHeight();

            if (cur_pos >= top && cur_pos <= bottom) {
              nav.find('a').parent().removeClass('active');
              //sections.removeClass('anvol-title');
              $(this).parent().find('.anvol-title:not(.anvol-title--no-lines)').addClass('anvol-title--active');
              nav.find('a[href="#'+$(this).attr('id')+'"]').parent().addClass('active');
            }
          });

          sections.each(function() {
            var top = $(this).offset().top - nav_height,
                bottom = top + $(this).outerHeight();

            if (cur_pos >= top && cur_pos <= bottom) {
              nav.find('a').parent().removeClass('active');
              //sections.removeClass('anvol-title');
              $(this).find('.anvol-title:not(.anvol-title--no-lines)').addClass('anvol-title--active');
              nav.find('a[href="#'+$(this).attr('id')+'"]').parent().addClass('active');
            }
          });
        });

        //mobile menu
        function anvol_toggle_mobile_menu() {
          $('.nav-primary').toggleClass('nav-primary--mobile-closed');
          $('.nav').toggleClass('nav--mobile-hidden');
          $('.nav-primary__mobile-menu-toggle').toggleClass('nav-primary__mobile-menu-toggle--active');
          $('body').toggleClass('body__mobile-menu-toggle--active');
        }

        $('.nav-primary__mobile-menu-toggle').click(function() {
          anvol_toggle_mobile_menu();
        });

        //close mobile menu in mobile when menu link is clicked
        $('.nav-primary li').not('.wpml-ls-item').click(function() {
          if (window.matchMedia('(max-width: 640px)').matches) {
            anvol_toggle_mobile_menu();
          }
        });

        //read more button for long texts in mobile size browser window
        function anvol_section__text_read_more() {
          if (window.matchMedia('(max-width: 767px)').matches) {
            $('.anvol-section__text--read-more').each(function() {
              if (! $(this).hasClass('anvol-section__text--read-more-closed') ) {
                if ($(this).outerHeight()>194) {
                  $(this).addClass('anvol-section__text--read-more-closed');
                }
              }
            });
          }
        }

        anvol_section__text_read_more();

        // tiny helper function to add breakpoints
        (function() {
          $(window).load(function() {
            $('.anvol-section__text-read-more').click(function() {
              $(this).prev().toggleClass('anvol-section__text--read-more-closed');
              $(this).hide();
            });

            $('.full-width-slider').slick({
              dots: true,
              autoplay: true,
              responsive: [
                {
                  breakpoint: 576,
                  settings: {
                    dots: false
                  }
                }
              ]
            });

            $('.slider-carousel-posts').slick({
              speed: 300,
              //slidesToShow: 3,
              //slidesToScroll: 3,
              slidesToShow: 2,
              slidesToScroll: 2,
              responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  }
                },
                {
                  breakpoint: 641,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  }
                }
              ]
            });

            $('.slider-carousel-brands').slick({
              speed: 300,
              slidesToShow: 4,
              slidesToScroll: 4,
              autoplay: true,
              responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                  }
                },
                {
                  breakpoint: 641,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  }
                }
              ],
            });
          });
        }());

        //resize functions
        function tablet_header() {
            if (window.matchMedia('(min-width:641px) and (max-width: 1199px)').matches) {
              if ($('.anvol-facts__fact').length) {
                var first_infobox_position_left = $('.anvol-facts__fact').position().left+11.5;
              }

              var background_width = $('#header-container__logo').css('width');

              if( window.innerWidth > 783 ) {
                $('#header-container__logo').addClass('header-container__max-374');
                background_width = '374px';
              } else {
                if ($('#header-container__logo').hasClass('header-container__max-374')) {
                  $('#header-container__logo').removeClass('header-container__max-374')
                };
              }

              $('#header-container__logo').css('left', first_infobox_position_left);
              $('#anvol-intro').css('padding-left', first_infobox_position_left + 23);
              $('#anvol-intro').css('margin-left', background_width);
            } else {
              $('#header-container__logo').removeAttr("style");
              $('#anvol-intro').removeAttr("style");
            }
        }

        tablet_header();

        function active_marker_in_tablet() {
            if (window.matchMedia('(min-width:641px) and (max-width: 1199px)').matches) {

              $('.nav-primary a').each().css('width', '10px');
            }
        }

        $(window).resize(function () {
          tablet_header();
          waitForFinalEvent( function() {
            anvol_section__text_read_more();
          }, 100, "anvol_section__create_read_more_button");

          waitForFinalEvent( function() {
            if (window.matchMedia('(min-width:641px) and (max-width: 1199px)').matches) {
              $('#anvol-facts').detach().insertAfter('#anvol-banner--facts');
            } else {
              $('#anvol-facts').detach().appendTo('#anvol-banner--facts');
            }
          }, 100, "media_queries");

        });

        $(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault();
            var animatedScrollTopValue = $($.attr(this, 'href')).offset().top;
            if ( $(this).parent().hasClass('menu-item--active-sooner') ) {
              animatedScrollTopValue-=25;
            }
            console.log(animatedScrollTopValue);
            $('html, body').animate({
              scrollTop: animatedScrollTopValue
             }, 500);
        });

        $('#anvol-intro__scrolled-logo').click(function() {
          $('html, body').animate({
            scrollTop: 0
          }, 500);
        });

        $('.footer__logo--scroll_to_top_on_click').click(function() {
          $('html, body').animate({
            scrollTop: 0
          }, 500);
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
